module.exports = __webpack_public_path__ + "img/hero-leadership.b623231d.jpg";